import apiClient from "./axiosInterceptor";
import { toast } from "react-toastify";

/* Razorpay SDK Loader */
const loadRazorpaySDK = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";

    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.body.appendChild(script);
  });
};

/* Main Payment Function */
export const initiatePayment = async ({
  plan_name,
  plan_id,
  user,
  email,
  onSuccess,
  onFailure,
  setLoading,
  billing_cycle,
  coupon_code
}) => {
  try {
    setLoading(plan_name);

    /* Load SDK */
    const sdkLoaded = await loadRazorpaySDK();

    if (!sdkLoaded) {
      toast.error("Razorpay SDK failed to load.",{theme: "colored"});
      setLoading(null);
      return;
    }

    if (!window.Razorpay) {
      toast.error("Payment system unavailable.",{theme: "colored"});
      setLoading(null);
      return;
    }

    /* Create Order */
    const orderResponse = await apiClient.post(`/payments/create-order`, {
      plan_id,
      billing_cycle,
      coupon_code
    });

    const orderData = orderResponse.data;

    if (!orderData?.order_id) {
      toast.error("Invalid order response.",{theme: "colored"});
      setLoading(null);
      return;
    }

    /* Razorpay Options */
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY,
      amount: orderData.amount,
      currency: orderData.currency,
      name: "XynexAI",
      description: `Subscription for ${plan_name}`,
      order_id: orderData.order_id,

      handler: async function (response) {
        try {
          const verifyResponse = await apiClient.post(
            `/payments/verify-payment`,
            {
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_signature: response.razorpay_signature,
            }
          );

          onSuccess?.(verifyResponse.data, response);
        } catch (error) {
          onFailure?.(error, response);
        } finally {
          setLoading(null);
        }
      },

      modal: {
        ondismiss: () => setLoading(null),
      },

      prefill: {
        name: user,
        email: email,
      },

      theme: {
        color: "#A855F7",
      },
    };

    const paymentObject = new window.Razorpay(options);

    paymentObject.on("payment.failed", async function (response) {
      try {
        await apiClient.post(`/payments/payment-failed`, {
          razorpay_order_id: response.error.metadata.order_id,
          razorpay_payment_id: response.error.metadata.payment_id,
        });

        toast.error("Payment Failed. Please try again.",{theme: "colored"});
      } catch (err) {
        toast.error("Payment failed.",{theme: "colored"});
      } finally {
        setLoading(null);
      }
    });

    paymentObject.open();
  } catch (error) {
    console.error("Payment Init Error:", error);
    toast.error("Unable to initiate payment.",{theme: "colored"});
    setLoading(null);
  }
};
